<div class="row no-gutters mt-3" *ngIf="order.hasOperations">
  <div class="order-item pointer" [class.order-item--is-open]="isOpen" (click)="onToggleOrder(order)">
    <div class="pointer mr-3" ngxClickStopPropagation (click)="onSelectOrder()" *ngIf="isSelectable">
      <i class="fa fa-check-square text-primary" *ngIf="order.isSelected"></i>
      <i class="far fa-square" *ngIf="!order.isSelected"></i>
    </div>
    <div class="d-flex flex-column mr-2 mt-1">
      <div class="blinker blinker--red mb-2 pointer"
           tooltipStr="Odstupanje od plana"
           (click)="onOpenDeviationModal()"
           ngxClickStopPropagation
          *ngIf="order.deviationFromPlan"></div>

      <div class="blinker blinker--blue" tooltipStr="Dodatno planiranje" *ngIf="order.additionalPlanningRequired"></div>
    </div>

    <div class="mr-2">
      <div>{{ order.client }}</div>
      <div>{{ order.name }}</div>
      <div class="font-weight-bold">{{ order.upisId }}</div>
      <div>{{ order.workOrderQuantity}} {{ order.workOrderUnit }}</div>
      <!-- <button class="btn btn-secondary btn-sm mt-2" 
              *ngIf="order.isDisplacementButtonVisible" 
              (click)="onOpenOperationsDisplacementModal()"
              ngxClickStopPropagation>Pomeri izabrane operacije</button> -->
    </div>

    <div class="order-item__stat">
      <app-progress-bar [type]="'time'"
                        [timeAvailable]="order.timeEstimatedEmployee"
                        [timeConsumed]="order.timeConsumedEmployeeTotal"></app-progress-bar>
      <app-progress-bar class="mt-1 d-flex"
                        [type]="'quantity'"
                        [timeAvailable]="order.lastOperationQuantity"
                        [timeConsumed]="order.lastOperationQuantityFinished"></app-progress-bar>

      <i class="fa fa-chevron-{{ isOpen ? 'up' : 'down' }} mt-2 font-12"></i>
    </div>
  </div>

  <div
    class="col"
    *ngFor="let day of order.dates | slice: sliceStart:sliceEnd; trackBy: trackByFn; let i = index;">
    <div class="day"
         [class.day--is-deadline]="dateHelper.isPastDeadline(order.deliveryDeadline, day.date)"
         [class.day--is-disabled]="dateHelper.isPastDay(day.date)">
      <div class="day__shifts">
        <div class="day__shift" *ngFor="let shift of day.shifts; trackBy: trackByFn; let i = index">
          <div class="day__shift-icons day__shift-icons--up">
            <i class="fa fa-clock" *ngIf="dateHelper.isDeadlineDay(order.deliveryDeadline, day.date)"></i>
            <div *ngFor="let partialDeadline of order.partialDeliveryInfo">
              <i class="fa fa-truck-loading pointer" *ngIf="partialDeadline.date === day.date" (click)="onOpenDeadlineModal(partialDeadline)"></i>
            </div>

            <i class="fa fa-rocket text-green" *ngIf="dateHelper.isDeadlineDay(order.productionDeadline, day.date)"></i>
          </div>
          <!-- Employee time-->
          <div *ngIf="viewOptionKey === 'timeEmployee'" class="text-center">
            <div class="font-weight-bold" [innerText]="shift.timeConsumedEmployee | digitFormat"></div>
            <div class="font-weight-bold border-top" [innerText]="shift.timePlannedEmployee | digitFormat"></div>
          </div>
          <!-- Machine time-->
          <div *ngIf="viewOptionKey === 'timeMachine'"
               class="font-weight-bold text-center"
               [innerText]="shift.timePlannedMachine | digitFormat"></div>

          <!-- Quantity-->
          <div *ngIf="viewOptionKey === 'quantity'" class="text-center">
            <div class="font-weight-bold border-bottom" [innerText]="shift.quantityFinished | digitFormat"></div>

            <div class="font-weight-bold" [innerText]="shift.quantityPlanned | digitFormat"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-question-modal *ngIf="isDeviationModalOpen"
                    [text]="'Da li želite da ignorišete odstupanje od plana?'"
                    (responseChanged)="onIgnoreDeviation($event)"></app-question-modal>

<app-deadline-details-modal *ngIf="isDeadlineModalOpen"
                            [orderDay]="selectedDay"
                            (responseChanged)="onCloseDeadlineModal()"></app-deadline-details-modal>
                          
<!-- <app-operations-displacement *ngIf="isOperationsDisplacementModal" [selectedOperations]="selectedOperations" (responseChanged)="handleOperationsDisplacementModal($event)"></app-operations-displacement> -->

